export const optimoveSetUserId = (userId?: number) => {
  if (typeof window === 'undefined') return;
  if (userId && window.optimoveSDKEnabled) {
    window.optimoveSDK.API.setUserId(userId.toString());
  }
};
